import DashboardCard from 'components/DashboardCard';
import React from 'react';
import { Module } from 'shared/services/prisma/types';
import { sum } from 'shared/constants/math';
import useDataSource from 'hooks/useDataSource';
import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { EDIT_HEATMAPS, EDIT_LICENSE, EDIT_SESSION_RECORDINGS } from 'shared/constants/permissions';
import { hasModuleLicense } from 'shared/utils/license';
import CenterContent from 'components/CenterContent';

const extraFields = `
  website {
    id
    matomoId
    matomoHeatmaps(dateRanges: [{ predefined: LAST_30_DAYS }]) {
      id
      samples
    }
    matomoSessionRecordings(dateRanges: [{ predefined: LAST_30_DAYS }]) {
      id
      samples
    }
  }
`;

function getStats(website) {
  if (website) {
    return [
      { title: 'Active heatmaps', value: website.matomoHeatmaps.filter(h => h.samples[0] > 0).length },
      { title: 'Heatmap samples', value: sum(website.matomoHeatmaps, { valueSelector: v => v.samples[0] }) },
      { title: 'Active recordings', value: website.matomoSessionRecordings.filter(h => h.samples[0] > 0).length },
      { title: 'Recorded sessions', value: sum(website.matomoSessionRecordings, { valueSelector: v => v.samples[0] }) },
    ];
  }

  return [];
}

const HsrCard = () => {
  const { dataSource, dataSourceId, loading, hasDataSourcePermission } = useDataSource({ extraFields });

  const hasHsr = hasModuleLicense(dataSource?.activeLicense, Module.Heatmaps);

  let cardContent = null;
  let cardProps = {};

  if (hasHsr) {
    const website = dataSource?.website;
    const websiteStats = getStats(website);
    const canEditHeatmaps = hasDataSourcePermission(EDIT_HEATMAPS);
    const canEditSessionRecordings = hasDataSourcePermission(EDIT_SESSION_RECORDINGS);
    cardProps = {
      statistics: websiteStats,
      resultsUrl: `/data-sources/${dataSourceId}/hsr/dashboard`,
      actions: [
        canEditHeatmaps ? (
          <Link key="manage-heatmaps" to={`/data-sources/${dataSourceId}/hsr/manage-heatmaps`}>
            <Button type="link" icon={<EditOutlined />}>Manage heatmaps</Button>
          </Link>
        ) : null,
        canEditSessionRecordings ? (
          <Link key="manage-recordings" to={`/data-sources/${dataSourceId}/hsr/manage-session-recordings`}>
            <Button type="link" icon={<EditOutlined />}>Manage recordings</Button>
          </Link>
        ) : null,
      ].filter(Boolean),
    };
  } else {
    const canEditLicense = hasDataSourcePermission(EDIT_LICENSE);
    cardContent = (
      <CenterContent>
        <p>
          Your license does not include Heatmaps & recordings.
        </p>
        {canEditLicense && (
          <Link to={`/data-sources/${dataSourceId}/settings/license`}>
            <Button type="primary">
              Upgrade license
            </Button>
          </Link>
        )}
      </CenterContent>
    );
  }

  return (
    <DashboardCard
      module={Module.Heatmaps}
      title="Heatmaps & recordings"
      name="heatmaps"
      period="Last 30 days"
      loading={loading}
      disabled={!hasHsr}
      {...cardProps}
    >
      {cardContent}
    </DashboardCard>
  );
};

export default HsrCard;
